<div class="p-fluid p-formgrid grid compact-form" style="padding: 0.5rem!important;" [formGroup]="money">
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="isPayment">Оплачено</label>
    <p-dropdown [options]="lstLogic" formControlName="isPayment" placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="datePayment">Дата оплаты</label>
    <p-calendar formControlName="datePayment" styleClass="calendar-compact" [showIcon]="true"
     [showOnFocus]="false" [showTime]="true" hourFormat="24"
      dateFormat="dd-mm-yy" dataType="string" inputId="datePayment"></p-calendar>
  </div>
  <div class="p-field col-12 md:col-6  compact-form">
    <label for="sponsorId">Компания-спонсор</label>
    <p-dropdown [options]="lstCompanies" formControlName="sponsorId"
    [filter]="true" [filterBy]="'label'"
    [style]="{height: '42px'}"
      placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-12 md:col-6 compact-form">
    <label for="paymentTypeId">Тип оплаты</label>
    <p-dropdown [options]="lstPaymentTypes" formControlName="paymentTypeId" [filter]="true" [filterBy]="'label'"
    [style]="{height: '42px'}"
      placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="paymentAmount">Сумма</label>
    <div class="p-inputgroup">
    <p-inputNumber formControlName="paymentAmount" inputId="locale-ru" mode="decimal" locale="ru-RU"
      [minFractionDigits]="2">
    </p-inputNumber>
    <button type="button" pButton pRipple icon="pi pi-money-bill" class="p-button-secondary" label="1500" (click)="onSetMoney(1500)"></button>
    <button type="button" pButton pRipple icon="pi pi-money-bill" class="p-button-secondary" label="1400" (click)="onSetMoney(1400)"></button>
    </div>
  </div>
  <div class="p-field col-6 md:col-6 compact-form">
    <label for="isMaterials">Выданы материалы</label>
    <p-dropdown [options]="lstLogic" formControlName="isMaterials" placeholder="Выберите" [resetFilterOnHide]="true">
    </p-dropdown>
  </div>
  <div class="p-field col-12 compact-form">
    <label for="paymentDocument">Документ об оплате</label>
    <input type="text" style="width: 100%" pInputText formControlName="paymentDocument">
  </div>
</div>
